import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { CommonService } from './shared/common.service';
import { CookieService } from 'ngx-cookie-service';
import { AppRoutingModule } from './app.routing';
import { ComponentsModule } from './components/components.module';
import { NotifierModule } from 'angular-notifier';
import { NgSelectModule } from '@ng-select/ng-select';
import { AppComponent } from './app.component';

import {
    AgmCoreModule
} from '@agm/core';
import { UserLayoutComponent } from './layouts/user-layout/user-layout.component';
import { LoginLayoutComponent } from './layouts/login-layout/login-layout.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { LoaderService } from './Providers/core-interceptor/loader.service';
import { InterceptorService } from './Providers/core-interceptor/core-interceptor.service';
import { CommonModule } from '@angular/common';
import { RedirectPolicyComponent } from './back-office/redirect-policy/redirect-policy.component';
import { RedirectTermsAndConditionComponent } from './back-office/redirect-terms-and-condition/redirect-terms-and-condition.component';
import { RedirectFaqComponent } from './back-office/redirect-faq/redirect-faq.component';
import { AdminLoginComponent } from './back-office/admin/admin-login/admin-login.component';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { AdminLoginLayoutComponent } from './layouts/admin-login-layout/admin-login-layout.component';
import { RedirectAboutUsComponent } from './back-office/redirect-about-us/redirect-about-us.component';
import { TermsOfUseComponent } from './back-office/terms-of-use/terms-of-use.component';
import { RulesAndRestrictionComponent } from './back-office/rules-and-restriction/rules-and-restriction.component';
// import { StandardPackageInquiryComponent } from './back-office/admin/standard-package-inquiry/standard-package-inquiry.component';
import { GtagModule, Gtag } from 'angular-gtag';
import { MobileDeleteAccountAdvisaryComponent } from './back-office/mobile-delete-account-advisary/mobile-delete-account-advisary.component';
@NgModule({
    imports: [
        BrowserAnimationsModule,
        CommonModule,
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        NgxSpinnerModule,
        ComponentsModule,
        RouterModule,
        AppRoutingModule,
        NgSelectModule,
        AgmCoreModule.forRoot({
            apiKey: 'YOUR_GOOGLE_MAPS_API_KEY'
        }),
        GtagModule.forRoot({ trackingId: 'G-C89JDXREPJ', trackPageviews: true }),
        NotifierModule.withConfig({
            // Custom options in here
            position: {
                horizontal: {
                    position: 'middle',
                    //distance: 50,
                },
                vertical: {
                    position: 'bottom',
                    distance: 50,
                    gap: 10
                },
            },
            //behaviour: {
            //  autoHide: false
            //}
        }),
    ],
    declarations: [
        AppComponent,
        UserLayoutComponent,
        LoginLayoutComponent,
        RedirectPolicyComponent,
        RedirectTermsAndConditionComponent,
        RedirectFaqComponent,
        AdminLayoutComponent,
        AdminLoginLayoutComponent,
        RedirectAboutUsComponent,
        TermsOfUseComponent,
        RulesAndRestrictionComponent,
        MobileDeleteAccountAdvisaryComponent,
        // StandardPackageInquiryComponent,
    ],
    providers: [CommonService, CookieService, LoaderService, Gtag,
        {
            provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true
        }
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    bootstrap: [AppComponent]
})
export class AppModule { }
